import { ResumeMainPage } from '../ResumeMainPage'
import { Education } from './Education.tsx'

export function EducationPage() {
    return (
        <ResumeMainPage index="Education">
            <Education />
        </ResumeMainPage>
    )
}
